import { PropsWithChildren } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const Mobile = ({ children }: PropsWithChildren) => {
  const { isMobile } = useResponsiveDesign()

  if (!isMobile) {
    return null
  }

  return <>{children}</>
}
